import { FormattedMessage } from 'react-intl'
import Chip from '@mui/material/Chip'

const statusColors = {
  initializing: 'info',
  starting: 'info',
  running: 'success',
  stopping: 'warning',
  off: 'default',
  deleting: 'warning',
  migrating: 'info',
  rebuilding: 'info',
  unknown: 'default',
  failed: 'error',
}

function HetznerServerStatusChip({ status }) {
  const color = statusColors[status] || 'default'

  return (
    <Chip
      label={<FormattedMessage id={`hetzner.server.status.${status}`} defaultMessage={status} />}
      color={color}
      size="small"
    />
  )
}

export default HetznerServerStatusChip
